import { InjectionToken } from '@angular/core';
import { BrowserOptions } from '@sentry/angular';

export const SENTRY_CONFIG = new InjectionToken<BrowserOptions>('SENTRY_CONFIG');